import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonLabel,
   IonList,
   IonIcon,
   IonFab,
   IonFabButton,
   IonGrid,
   IonProgressBar,
   IonRow,
   IonCol,
   IonToast,
   IonInfiniteScroll,
   IonInfiniteScrollContent,
   IonSearchbar,
   IonSpinner,
   IonButton,
   IonActionSheet,
   IonLoading
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { createOutline, add, checkmarkCircle, refresh, refreshOutline, copyOutline, documentTextOutline, alarmOutline, analyticsOutline, trashOutline } from 'ionicons/icons';
import { useLocation, withRouter } from "react-router";
import { useHistory } from 'react-router-dom';
import './Workflow.css';
import ServerService from '../../../services/Server';
//import { Environment } from "../../../data/Environment";
import OpenMenuButton from "../../../components/OpenMenuButton";
import StatusBanner, { getBannerParam } from '../../../components/StatusBanner';
import StatusCircle, { getCircleParam } from '../../../components/StatusCircle';
import Label from '../../../components/Label';
import HistoryModal from '../../../components/HistoryModal';
import ApprovalChainModal from '../../../components/ApprovalChainModal';
import DocumentModal from '../../../components/DocumentModal';

const JSON5 = require("json5")

interface WorkflowPageProps extends RouteComponentProps<{
  mid : string;
  hid : string;
  name : string;
}> {}

interface LocationState {
  canCreate : boolean,
  canEdit : boolean,
  canCopy : boolean
}

const Workflow: React.FC<WorkflowPageProps> = ({match}) => {

 // const { name } = useParams<{ name: string; }>();
 //const name:string = "Workflow";

 const [error, setError] = useState(null);
 const [errMsg, setErrMsg] = useState("");
 const [errColor, setErrColor] = useState("danger");
 const [colCfgs, setColCfgs] = useState([]);
 const [statusStrs, setStatusStrs] = useState(new Map());
 const [tasks, setTasks] = useState([]);
 const [loading, setLoading] = useState(true);
 const [searchTerm, setSearchTerm] = useState("");
 const [disableInfiniteScroll, setDisableInfiniteScroll] = useState(false);
 const [start, setStart] = useState(0);
 const [limit, setLimit] = useState(20);
 const [refreshAll, setRefreshAll] = useState(true);
 const [taskCount, setTaskCount] = useState(0);
 const [totalCount, setTotalCount] = useState(0);
 const [noMoreTask, setNoMoreTask] = useState(false);
 const [pgCircle, setPgCircle] = useState({});
 const [pgCircleText, setPgCircleText] = useState({});
 const [pgText, setPgText] = useState({});
 const [pgBanner, setPgBanner] = useState({});
 const [pgBorder, setPgBorder] = useState({});
 const [showActionSheet, setShowActionSheet] = useState(false);
 const [showActionSheetDraft, setShowActionSheetDraft] = useState(false);
 const [showHistory, setShowHistory] = useState(false);
 const [showApprovalChain, setShowApprovalChain] = useState(false);
 const [showDocuments, setShowDocuments] = useState(false);
 const [showLoading, setShowLoading] = useState(false);
 const [showConfirm, setShowConfirm] = useState(false);
 const [actMap, setActMap] = useState({header:'',msg:'',action:null});
 
 const server = new ServerService();
 var state = server.state;
 const history = useHistory();
 server.setHistory(history);

 const location = useLocation<LocationState>();
 const { canCreate, canEdit, canCopy } = location.state || { canCreate: true ,canEdit: true ,canCopy: true}

 const now = new Date();
 const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();

 const fetchTasks = function(state:any, retry:boolean) {
  console.log("fetchTask("+state+" , "+retry+"), tasks.length:"+tasks.length+", start:"+start+" ,limit:"+limit)
  setLoading(true);
  
  const data = {
    id:match.params.hid,
    s:searchTerm,
    start:(start>=0 ? start : 0).toString(),
    limit:limit.toString(),
    m:"1"
  }
  fetch(server.getFullUrl("memo/list", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        setLoading(false);
        setTasks([...tasks, ...result.data]);

        setTaskCount(tasks.length + result.data.length);
        setTotalCount(result.total);

        setStart((start>=0 ? start : 0) + (result ? result.data.length : 0));

        setDisableInfiniteScroll(!result || result.data.length < limit);
        setNoMoreTask(start>0 && (!result || result.data.length< limit));
        console.log("disableInfiniteScroll:"+(!result || result.data.length < limit))
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        console.log("fetchTask err 1");
        setStart(0);
        setLoading(false);
        if (retry) {
          server.login((success:boolean, msg:string) => {
            if (success) {
              console.log("fetchTask success");
              fetchTasks(server.state, false)
            } else {
              console.log("fetchTask err 2");
              setErrMsg(msg);
              setError(true);
            }
          });
        } else {
          console.log("fetchTask err 3");
          setErrMsg(error);
          setError(true);
        }
      }
   ).catch(e => {
      console.log("fetchTask err 4");
      setErrMsg(e);
      setError(true);
      setLoading(false);
   })
  ).catch(e => {
      console.log("fetchTask err 5");
      setErrMsg("Please check Internet Connection!");
      setErrColor("dark");
      setError(true);
      setLoading(false);
  })
}

const statusImage = new Map([
  ["D","#d6d6d6"],
  ["W","#FFD800"],
  ["R","red"],
  ["X","#4E4E4E"],
  ["C","green"],
  ["S","purple"]
]);

const statusStr = new Map([
["D","Draft"],
["W","Wait for Approval"],
["R","Rejected"],
["X","Cancelled"],
["C","Completed"],
["S","Consulting"]
]);

//  const taskStatusImage = function(status:string) {
//   var img = "";
//   if (!status) {
//     img = "white";
//   } else {
//     img = statusImage.get(status);
//   }

// /*
//   indicator:{
// 		"D":{color:"gray", text_th:"Draft", text_en:"Draft"},
// 		"W":{color:"yellow", text_th:"รอการอนุมัติ", text_en:"Wait for Approval"},
// 		"R":{color:"red", text_th:"ไม่อนุมัติ", text_en:"Rejected"},
// 		"X":{color:"darkgray", text_th:"ยกเลิก", text_en:"Cancelled"},
// 		"C":{color:"green", text_th:"ปิดงาน", text_en:"Completed"},
// 		"S":{color:"purple", text_th:"ขอคำปรึกษา", text_en:"Consulting"}
// 	},
//   */
//   return "assets/img/beam"+img+".png";
//  }

//  const taskStatusStr = function(status:string) {
//   var img = "";
//   if (!status) {
//     img = "Unknown : "+status;
//   } else {
//     img = statusStr.get(status);
//   }

//   return img;
// }

const loadData = async (event:CustomEvent<void>) => {
  console.log("loadData()");
  await fetchTasks(state, true);
  (event.target as HTMLIonInfiniteScrollElement).complete();
}

const fetchConfig = function(state:any, retry:boolean) {
  server.log("fetchConfig("+state+" , "+retry+")")
  const data = {
  }
  
  fetch(server.getFullUrl("main/mytask/cfg/list", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        if (result.success) {

          var flag1 = result.data.MB_PG_CIRCLE.flag1;
          console.log("cfg.MB_PG_CIRCLE:"+flag1);
          setPgCircle(JSON5.parse("["+flag1+"]"));
        
          flag1 = result.data.MB_PG_CIRCLE_TEXT.flag1;
          console.log("cfg.MB_PG_CIRCLE_TEXT:"+flag1);
          setPgCircleText(JSON5.parse("["+flag1+"]"));

          flag1 = result.data.PG_BANNER.flag1;
          console.log("cfg.PG_BANNER:"+flag1);
          setPgBanner(JSON5.parse("["+flag1+"]"));

          flag1 = result.data.PG_TEXT.flag1;
          console.log("cfg.PG_TEXT:"+flag1);
          setPgText(JSON5.parse("["+flag1+"]"));

          flag1 = result.data.PG_BORDER.flag1;
          console.log("cfg.PG_BORDER:"+flag1);
          setPgBorder(JSON5.parse(flag1));
        }
      },
      (error) => {
        server.log("config err 1");
        if (retry) {
          server.login((success:boolean, msg:string) => {
            if (success) {
              server.log("config success");
              fetchConfig(server.state, false)
            } else {
              server.log("config err 2");
              setErrMsg(msg);
              setError(true);
            }
          });
        } else {
          server.log("config err 3");
          setErrMsg(error);
          setError(true);
        }
      }
   ).catch(e => {
      server.log("config err 4");
      setErrMsg(e);
      setError(true);
   })
  ).catch(e => {
      server.log("config err 5");
      setErrMsg("Please check Account Settings or Internet Connection!");
      setErrColor("dark");
      setError(true);
  })
}

const fetchStatusStr = function(state:any, retry:boolean) {
  server.log("fetchStatusStr("+state+" , "+retry+")")
  const data = {}
  
  fetch(server.getFullUrl("memo/status/list", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        if (result.success) {

          const rData = result.data;
          var statusStrs:any[] = [];

          for(let entry in rData) {
            let text = rData[entry].text_en;
            const e = [entry, text];

            statusStrs.push(e);
          }

          setStatusStrs(new Map(statusStrs));

        }
      },
      (error) => {
        server.log("statusstr err 1");
        if (retry) {
          server.login((success:boolean, msg:string) => {
            if (success) {
              server.log("statustr success");
              fetchStatusStr(server.state, false)
            } else {
              server.log("statustr err 2");
              setErrMsg(msg);
              setError(true);
            }
          });
        } else {
          server.log("statusstr err 3");
          setErrMsg(error);
          setError(true);
        }
      }
   ).catch(e => {
      server.log("statusstr err 4");
      setErrMsg(e);
      setError(true);
   })
  ).catch(e => {
      server.log("statustr err 5");
      setErrMsg("Please check Account Settings or Internet Connection!");
      setErrColor("dark");
      setError(true);
  })
}

const fetchColConfig = function(state:any, retry:boolean) {
  server.log("fetchColConfig("+state+" , "+retry+")")
  const data = {
    mid:match.params.mid,
    all:"False"
  }
  
  fetch(server.getFullUrl("admin/mobile/workflow/col/list", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        if (result.success) {

          const rData = result.data;
          var colCfgs = [];

          for(let entry of rData) {
            const e = {
              size:"",
              flex:"",
              items:[{}]
            }

            //console.log("style:"+entry.spcParam);
            const style = JSON5.parse("{"+entry.spcParam+"}")
            if(style.size) {
              e.size = style.size;
            } else {
              e.flex = style.flex;
            }
            //console.log("items:"+entry.dformat);
            e.items = JSON5.parse("["+entry.dformat+"]");

            colCfgs.push(e);
          }

          setColCfgs(colCfgs);

        }
      },
      (error) => {
        server.log("colconfig err 1");
        if (retry) {
          server.login((success:boolean, msg:string) => {
            if (success) {
              server.log("colconfig success");
              fetchConfig(server.state, false)
            } else {
              server.log("colconfig err 2");
              setErrMsg(msg);
              setError(true);
            }
          });
        } else {
          server.log("colconfig err 3");
          setErrMsg(error);
          setError(true);
        }
      }
   ).catch(e => {
      server.log("colconfig err 4");
      setErrMsg(e);
      setError(true);
   })
  ).catch(e => {
      server.log("colconfig err 5");
      setErrMsg("Please check Account Settings or Internet Connection!");
      setErrColor("dark");
      setError(true);
  })
}

const format = (s:string, args:any) => {     
  for (let attr in args) 
    if (args.hasOwnProperty(attr)) 
      s = s.split('${' + attr + '}').join(args[attr]);     

  return s || ''; 
}

const htmlRenderer = (colCfg:any, task:any) => {
  task.statusStr = statusStrs.get(task.status) || statusStr.get(task.status);

  return format(colCfg.format,task)
}

const fetchSystemConfig = function(state:any, retry:boolean) {
server.log("fetchSystemConfig("+state+" , "+retry+")")
const data = {
  p1:"MOBILE_MY_TASK_PAGING"
}

fetch(server.getFullUrl("srcUrl/main/systemConfig", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if (result.success) {
        server.log("flag1:"+(result.data[0] ? result.data[0].name : ""))
        if (result.data[0] && result.data[0].name) {
          setLimit(parseInt(result.data[0].name));
        }
        setTasks([]);
        setStart(start === -1 ? -2 : -1);
      }
    },
    (error) => {
      server.log("systemConfig err 1");
      if (retry) {
        server.login((success:boolean, msg:string) => {
          if (success) {
            server.log("systemConfig success");
            fetchSystemConfig(server.state, false)
          } else {
            server.log("systemConfig err 2");
            setErrMsg(msg);
            setError(true);
          }
        });
      } else {
        server.log("systemConfig err 3");
        setErrMsg(error);
        setError(true);
      }
    }
 ).catch(e => {
    server.log("systemConfig err 4");
    setErrMsg(e);
    setError(true);
 })
).catch(e => {
    server.log("systemConfig err 5");
    setErrMsg("Please check Account Settings or Internet Connection!");
    setErrColor("dark");
    setError(true);
})
}

useEffect(() => {
  console.log("Workflow : useEffect")

  fetchStatusStr(state, true);
  fetchConfig(state, true);
  fetchColConfig(state, true);
  fetchSystemConfig(state, true);

}, [state, searchTerm, refreshAll])

useEffect(() => {
  console.log("Workflow : useEffect 2,"+start)
  if (start < 0) {
    setTaskCount(0)
    setDisableInfiniteScroll(false)
    fetchTasks(state, true)
  }
}, [start])

useEffect(() => {
  console.log("Workflow : useEffect 3,"+dummy+",lastUrl:"+server.lastUrl)
  const el = document.getElementsByTagName("ion-col")
  //console.log("el.length:"+el.length)
  var found0 = false;
  var found = false;
  for(var i=0; i<el.length; i++) {
    //console.log(el[i].clientWidth)
    if (i>0 && !found0 && el[i].clientWidth === 0) {
      found0 = true
    }
    else
    if (found0 && i>0 && !found && el[i].clientWidth>0) {
      found = true
    }
  }
  if (el.length>1 && found) {
    console.log("reload()")
    //window.location.reload();
    history.replace(server.lastUrl.path,server.lastUrl.state)
  }
}, [dummy])

const actionSheetBtns = () => {
  let buttons = []

  buttons.push({
    text: 'Documents',
    icon: documentTextOutline,
    handler: () => {
      setShowDocuments(true)
    }
  })

  if (canCopy) {
    buttons.push({
      text: 'Copy',
      icon: copyOutline,
      handler: () => {
        setActMap({header:'Copy Workflow',msg:"Copy "+server.task.id+"?",action:actCopy})
        setShowConfirm(true)
      }
    })
  }

  buttons.push({
    text: 'History',
    icon: alarmOutline,
    handler: () => {
      setShowHistory(true)
    }
  })

  buttons.push({
    text: 'Approval Chain',
    icon: analyticsOutline,
    handler: () => {
      setShowApprovalChain(true)
    }
  })

  return buttons
}

const draftActionSheetBtns = () => {
  let buttons = []
  
  if (canEdit) {
    buttons.push({
      text: 'Edit',
      icon: createOutline,
      handler: () => {
        //"/page/home/workflows/form/"+task.id+"/a/"+dummy
        history.push("/page/home/workflows/form/"+server.task.id+"/"+match.params.hid+"/"+dummy)
      }
    })
  }
  
  if (canCopy) {
    buttons.push({
      text: 'Copy',
      icon: copyOutline,
      handler: () => {
        setActMap({header:'Copy Workflow',msg:"Copy "+server.task.id+"?",action:actCopy})
        setShowConfirm(true)
      }
    })
  }

  if (server.task.action && server.task.action.indexOf("D")>=0) {
    buttons.push({
      text: 'Delete',
      icon: trashOutline,
      handler: () => {
        setActMap({header:'Delete Workflow',msg:"Delete "+server.task.id+"?",action:actDelete})
        setShowConfirm(true)
      }
    })
  }

  return buttons;
}

const actDelete = () => {
  setShowLoading(true);
  console.log("Delete "+server.task.id)

  var params: any = {
    "id":server.task.id
  }

  fetch(server.getPrefixUrl()+"memo/delete",server.postRequest(params,{})).then(
    response => response.json() // if the response is a JSON object
  ).then(res => {
    setShowLoading(false);
    if (res.success) {
      setTasks([]);
      setStart(start === -1 ? -2 : -1);
    } else {
      console.log(res.message);
    }
  }).catch(
    error => {
      setShowLoading(false);
      console.log(error) // Handle the error response object
    }
  );
}

const actCopy = ()  => {
  setShowLoading(true);
  console.log("copy "+server.task.id)

  var params: any = {
    "id":server.task.id
  }

  fetch(server.getPrefixUrl()+"mb/memo/copy",server.postRequest(params,{})).then(
    response => response.json() // if the response is a JSON object
  ).then(res => {
    setShowLoading(false);
    if (res.success) {
      setTasks([]);
      setStart(start === -1 ? -2 : -1);
    } else {
      console.log(res.message);
    }
  }).catch(
    error => {
      setShowLoading(false);
      console.log(error) // Handle the error response object
    }
  );
}

var cols: {}[];

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{match.params.name} ({taskCount}/{totalCount})</IonTitle>
          {loading ?(
                 <><IonSpinner slot="end" name="lines" color="primary"/><IonLabel slot="end">&nbsp;</IonLabel></>
          ):""}
          <IonButtons slot="end">
             <IonButton hidden={loading} onClick={e => {setRefreshAll(refreshAll ? false : true)}}><IonIcon icon={refresh}></IonIcon></IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonSearchbar value={searchTerm} debounce={1000} onIonChange={e => {setSearchTerm(e.detail.value)}}/>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{match.params.name} ({taskCount}/{totalCount})</IonTitle>
          </IonToolbar>
        </IonHeader>

        {canCreate ?
        (
        <IonFab vertical="bottom" horizontal={server.state.handed==="right" ? "end" : "start"} slot="fixed">
          <IonFabButton routerLink={"/page/home/workflows/form/0/"+match.params.hid+"/"+dummy}>
            <IonIcon icon={add} />
          </IonFabButton>
        </IonFab>
        ) : ""}

        <IonList>
          <IonGrid>
          {tasks.map((task,i) => {
                //console.log("task:"+task+":"+task.status);

                cols = [];

                colCfgs?.forEach((colCfg,j) => {
                  var col;
                  var items:{}[] = [];

                  //var wt = false;

                  colCfg.items.forEach((colItem:any, k:any) => {
                    var item;

                    //console.log("colItem.type:"+colItem.type);
                    if (colItem.type === "S") {
                      //console.log("type:S");
                      item = (
                        <svg key={k} width={colItem.width} height={colItem.height}>
                          <rect x={colItem.x} y={colItem.y} width={colItem.w} height={colItem.h} style={{fill:statusImage.get(task.status)}}/>
                        </svg>
                      )
                    } else 
                    if (colItem.type === "WP") {
                      //console.log("type:WP");
                      const ccParam = task.status!=="D" ? getCircleParam(task.wfBanner, task.wfMbInfo, pgCircle, pgCircleText) : {text:"Draft"};
                      item = (
                        <StatusCircle key={k} ccParam={ccParam} textSize={colItem.textSize}></StatusCircle>
                      )
                    } else 
                    if (colItem.type === "L") {
                      //console.log("type:L");
                      item = (
                        <Label className="ion-text-wrap" key={k} width={colItem.width} colItem={colItem} html={htmlRenderer(colItem, task)}></Label>
                      )
                    } else 
                    if (colItem.type === "T") {
                      //console.log("type:T");
                      item = (
                          <span dangerouslySetInnerHTML={{__html: htmlRenderer(colItem, task)}}></span>
                      )
                    } else 
                    if (colItem.type === "WT") {
                      //console.log("type:WT");
                      //wt = true;
                      const bnParam = task.status!=="D" ? getBannerParam(task.wfBanner, pgBanner, pgText, pgBorder) : {};
                      item = (
                        <StatusBanner key={k} bnParam={bnParam} width={colItem.width} colItem={colItem}></StatusBanner>
                      )
                    }

                    items.push(item)
                  })

                  col = (
                    <IonCol key={j} size={colCfg.size ? colCfg.size : {flex: colCfg.flex}} className="ion-align-self-stretch">
                      <>
                      {items}
                      </>
                    </IonCol>
                  )

                  cols.push(col)
                })

                return (
                  <IonItem key={i} detail={false} className="ion-no-padding" onClick={(e) => {server.task = task;if(task.status==="D") setShowActionSheetDraft(true); else setShowActionSheet(true) }}>
                    <IonRow className="ion-nowrap ion-align-items-stretch">
                    <>{cols}</>
                    </IonRow>
                  </IonItem>
                )
            })}
          </IonGrid>

          <IonItem className={loading ? '' : 'ion-hide'}>
            <IonProgressBar type="indeterminate"></IonProgressBar>
          </IonItem>

        </IonList>

        <IonInfiniteScroll threshold="10%" disabled={disableInfiniteScroll} onIonInfinite={loadData}>
          <IonInfiniteScrollContent
            loadingSpinner="circles"
            loadingText="Loading more tasks...">
          </IonInfiniteScrollContent>
        </IonInfiniteScroll>

          <IonToast
            isOpen={noMoreTask}
            message={'No More Task'}
            duration={2000}
            onDidDismiss={() => setNoMoreTask(false)}
            position="middle"
          />

          <IonLoading
            className='my-custom-class'
            isOpen={showLoading}
            onDidDismiss={() => setShowLoading(false)}
            message={'Please wait...'}
            duration={5000}
          />

          <IonToast
            isOpen={error}
            message={errMsg}
            position="middle"
            color={errColor}
            buttons={[
              {
                side: 'end',
                icon: checkmarkCircle,
                text: 'OK',
                role: 'cancel',
                handler: () => {
                  setError(false);
                  setErrColor("danger");
                }
              },{
                text:'Refresh',
                icon: refreshOutline,
                handler: () => {
                  setError(false);
                  setErrColor("danger");
                  window.location.reload();
                }
              }
            ]}
          />

        <IonActionSheet
          isOpen={showActionSheet}
          onDidDismiss={() => setShowActionSheet(false)}
          className='my-custom-class'
          header="Action"
          translucent={true}
          buttons={actionSheetBtns()}
        >
        </IonActionSheet>

        <IonActionSheet
          isOpen={showActionSheetDraft}
          onDidDismiss={() => setShowActionSheetDraft(false)}
          className='my-custom-class'
          header="Action"
          translucent={true}
          buttons={draftActionSheetBtns()}
        >
        </IonActionSheet>

        <HistoryModal id={server.task.id} isOpen={showHistory}
            onDismiss={() => {setShowHistory(false)}}/>

        <ApprovalChainModal id={server.task.id} isOpen={showApprovalChain}
            onDismiss={() => {setShowApprovalChain(false)}}/>

        <DocumentModal id={server.task.id} isOpen={showDocuments}
            onDismiss={() => {setShowDocuments(false)}}/>

        <IonActionSheet
          isOpen={showConfirm}
          onDidDismiss={() => setShowConfirm(false)}
          className='my-custom-class'
          header={actMap.msg}
          buttons={[
            {
              text: 'No',
              role: 'cancel'
            },
            {
              text: 'Yes',
              handler: () => {
                actMap.action()
              }
            }
          ]}
        />

      </IonContent>
    </IonPage>
  );
};

export default withRouter(Workflow);
